import React, { useEffect } from 'react';
import { Field, Form, getFormValues, reduxForm } from 'redux-form';
import styles from '../../styles/forms/add_plan_setting_template_wizard/AddPlanSettingTemplateForm.scss';
import Button from '../../components/Button';
import { connect } from 'react-redux';
import { __ } from '../../core/utils';
import { subscribe } from 'react-contextual/dist/react-contextual.es';
import Localization from '../../helpers/Localization';
import { map, isEmpty, get, toNumber } from 'lodash';
import { withRouter } from 'react-router';
import Input from '../../components/Input';
import Select from '../../components/Select';
import GridTable from '../../components/GridTable';

const AddPlanSettingTemplateForm = ({
  handleSubmit,
  onClose,
  submitting,
  values,
}) => {
  const generateColumns = (count) => {
    const cols = [];
    for (let i = 0; i < count; i++) {
      let n = i;
      let s = '';
      do {
        s = String.fromCharCode(65 + (n % 26)) + s;
        n = Math.floor(n / 26) - 1;
      } while (n >= 0);
      cols.push(s);
    }
    return cols;
  };

  const generateRows = (count) =>
    Array.from({ length: count }, (_, i) => String(i + 1));

  const generateCells = (colCount, rowCount) => {
    const cols = generateColumns(colCount);
    const rows = generateRows(rowCount);
    return cols.flatMap((c) => rows.map((r) => `${c}${r}`));
  };

  const cols = generateColumns(26);
  const rows = generateRows(20);

  //const keys = generateCells(26, 20);

  return (
    <Form onSubmit={handleSubmit} className={styles.wrapper}>
      <div className={styles.form}>
        <Field
          name='name'
          component={Input}
          label={__('plan-setting-templates.field.name')}
        />

        <div className={styles.flex}>
          <div className={styles.f1}>
            <Field
              name='grid_columns_count'
              component={Select}
              label={__('plan-setting-templates.field.grid-columns')}
              searchable
              options={map(cols, (col, i) => {
                return { value: i + 1, label: col };
              })}
            />
          </div>
          <div className={styles.f1}>
            <Field
              name='grid_rows_count'
              component={Select}
              searchable
              noSort
              label={__('plan-setting-templates.field.grid-rows')}
              options={map(rows, (row, i) => {
                return { value: row, label: row };
              })}
            />
          </div>
        </div>

        {values?.grid_rows_count && values?.grid_columns_count && (
          // <Field
          //   name={`cells`}
          //   component={GridTable}
          //   rows={toNumber(values?.grid_rows_count)}
          //   cols={toNumber(values?.grid_columns_count)}
          // />

          <div className={styles.cellsWrapper}>
            {map(generateRows(values.grid_rows_count), (row) => (
              <div className={styles.row} key={row}>
                {map(generateColumns(values.grid_columns_count), (col) => {
                  const key = `${col}${row}`;
                  return (
                    <div className={styles.cell}>
                      <Field
                        key={key}
                        name={`cells[${key}]`}
                        component={Input}
                        placeholder={key}
                      />
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        )}
      </div>
      <div className={styles.footer}>
        <Button
          lightGray
          medium
          left
          middleText={__('button.cancel')}
          onClick={onClose}
        />

        <Button
          lightBlue
          medium
          middleText={__('button.add')}
          spinning={submitting}
          onClick={handleSubmit}
        />
      </div>
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    values: getFormValues(
      'add_plan_setting_template_wizard.add_plan_setting_template'
    )(state),
  };
};

export default withRouter(
  reduxForm({
    form: 'add_plan_setting_template_wizard.add_plan_setting_template',
    enableReinitialize: true,
  })(
    connect(
      mapStateToProps,
      null
    )(subscribe(Localization, 'localization')(AddPlanSettingTemplateForm))
  )
);
